import { logEvent } from "firebase/analytics";
import { analytics } from "./";

export const logAnalyticsEvent = (event: string, params?: any) =>
    logEvent(analytics, event, params);
